// Modules
import React, { useState } from 'react'
import { FormikProps, Form, Field } from 'formik'
import { Button, Radio } from '@dasa-health/components-react'

// Application
import { useSignUp } from 'context'
import QuestionMark from 'assets/question-mark.svg'
import { PhoneContact, EmailContact, ContactTypes } from 'typings/signup'

// Components
import { HelpModal } from 'components'
import { StyledForm } from './styles'

export interface FormValues {
    contactId?: string
    contactValue?: string
    contactType?: string
    phoneContacts: Array<PhoneContact>
    emailContacts: Array<EmailContact>
}

type FormType = FormikProps<FormValues>

export const InnerForm: React.FC<FormType> = props => {
    const { handleSubmit, setFieldValue, values } = props
    const [showModal, setShowModal] = useState(false)
    const { isLoading } = useSignUp()

    const handleFieldChange = (id: number, label: string, type: ContactTypes) => {
        setFieldValue('contactId', id)
        setFieldValue('contactType', type)
        setFieldValue('contactValue', label)
    }

    return (
        <StyledForm>
            <Form autoComplete="off" data-testid="select-contact-form" onSubmit={handleSubmit}>
                <div className="form__radio-button">
                    {values.phoneContacts.map((item: PhoneContact) => (
                        <div className="form__radio" key={item.id}>
                            <Field
                                as={Radio}
                                data-testid="radio-input"
                                defaultChecked={item.id === parseInt(values.contactId as string, 10)}
                                label={item.value}
                                name="selectedContact"
                                onChange={() => handleFieldChange(item.id, item.value, ContactTypes.MOBILE)}
                                value={item.id}
                            />
                        </div>
                    ))}
                    {values.emailContacts.map((item: EmailContact) => (
                        <div className="form__radio" key={item.id}>
                            <Field
                                as={Radio}
                                data-testid="radio-input"
                                defaultChecked={item.id === parseInt(values.contactId as string, 10)}
                                label={item.value}
                                name="selectedContact"
                                onChange={() => handleFieldChange(item.id, item.value, ContactTypes.EMAIL)}
                                value={item.id}
                            />
                        </div>
                    ))}
                </div>

                <footer>
                    <Button
                        data-testid="submit-button"
                        disabled={!values.contactId}
                        isLoading={isLoading}
                        size="default"
                        type="submit"
                        variant="primary"
                    >
                        Continuar
                    </Button>
                </footer>
                <HelpModal
                    image={QuestionMark}
                    link={{ to: '/login', text: 'Ir para o início' }}
                    setShowModal={setShowModal}
                    showModal={showModal}
                    subtitle="Entre em contato com a nossa equipe de ajuda nos telefones:"
                    title="Seus dados estão incorretos?"
                />
            </Form>
        </StyledForm>
    )
}
